export const setCookies = cookies => ({
    type: 'SET_COOKIES',
    cookies
});

export const setReqConfig = config => ({
    type: 'SET_REQUESTS_CONFIG',
    config
});

export const clearHeaders = () => ({
    type: 'CLEAR_HEADERS'
});

export const setQueryParam = queryParam => ({
    type: 'SET_QUERY_PARAM',
    queryParam
});

export const setLanguageOnboardingFlag = showLanguageOnboarding => ({
    type: 'SET_LANG_ONBOARD_FLAG',
    showLanguageOnboarding
});

export const setClientIpPort = responseHeaders => ({
    type: 'SET_CLIENT_IP_PORT',
    responseHeaders
});
